export const EMOTION_SHOW_TABS = [
  'general',
  'publications',
  'collection',
  'search',
] as const;

export type EmotionShowTab = (typeof EMOTION_SHOW_TABS)[number];

export const EMOTION_DEFAULT_TAB: EmotionShowTab = 'general';
